import { addDoubleQuotes } from '../utils/smartutils';

export default function surveyAnswerSave(values) {
  const updatedValues = { ...values };
  delete updatedValues.survey.startDate;
  delete updatedValues.survey.endDate;
  delete updatedValues.survey.deny;
  return `mutation {
      surveyAnswerSave(
        answer: { 
          id: 0, 
          survey: ${JSON.stringify(updatedValues.survey).replace(
            /"([^(")"]+)":/g,
            '$1:'
          )}, 
          observation: ${addDoubleQuotes(updatedValues.observation)}, 
          score: ${updatedValues.score} 
        }
      ) { id }
  }`;
}
